<template>
<modal-dialog :modal-visible="visible"
	:title="title"
	cancel-button-text="Done"
	:submit-visible="false"
	v-on:closeModal="$emit('closeModal')">

	<div>

		<div class="d-flex justify-content-between align-items-center">
			<h4>{{ recordTitle }}</h4>

			<!--
			<info-box style="display: inline-block;margin-bottom: 15px;"
				label="Total Hours"
				:value="compiledEditModal.record.hrs">
			</info-box>
			-->
		</div>

		<slot></slot>

		<field-with-inline-button v-if="showGlobalRate" label="Global Rate"
			button-text="Save"
			button-class="btn-primary"
			:params="{
				type: 'number'
			}"
			v-model="payload.rate"
			v-on:buttonClick="$emit('saveValue',{field:'rate',value:payload.rate})">
		</field-with-inline-button>

		<field-with-inline-button label="Global Price Adjustment"
			button-text="Save"
			button-class="btn-primary"
			:params="{
				type: 'number',
				step: 0.0001
			}"
			v-model="payload.price_adjustment"
			v-on:buttonClick="$emit('saveValue',{field:'price_adjustment',value:payload.price_adjustment})">
		</field-with-inline-button>

		<field-with-inline-button label="Global Markup"
			button-text="Save"
			button-class="btn-primary"
			:params="{
				type: 'number',
				step: 0.001
			}"
			v-model="payload.markup"
			v-on:buttonClick="$emit('saveValue',{field:'markup',value:payload.markup})">
		</field-with-inline-button>

		<info-box v-if="record" class="float-right"
			label="Total Value"
			:value="totalValue.toCurrency()">
		</info-box>

	</div>

</modal-dialog>
</template>
<script type="text/javascript">
	
import ModalDialog from "@/components/ModalDialog"
import FieldWithInlineButton from "@/components/FieldWithInlineButton"
import InfoBox from "@/components/InfoBox"

export default {
	name: "BulkPricingEditModal",
	components: {
		FieldWithInlineButton,
		ModalDialog,
		InfoBox
	},
	props: [
		"visible",
		"title",
		"recordTitle",
		"record",
		"showGlobalRate"
	],
	data() {
		return {
			payload: {
				rate: "",
				price_adjustment: 1,
				markup: 1
			}
		}
	},
	watch: {
		visible() {
			this.payload = {
				rate: "",
				price_adjustment: 1,
				markup: 1
			}
		}
	},
	computed: {
		totalValue() {
			if (!this.record)
				return 0

			return  +this.record.qty * +this.payload.rate * +this.payload.price_adjustment * this.payload.markup
		}
	}
}
</script>